import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ContactContent } from "feature/components/Contact/ContactContent";
import { HomeComponent } from "feature/components/Home/HomeComponent";
import { HomeSkyBackground } from "feature/components/Home/HomeSkyBackground";
import { HomeStatsSection } from "feature/components/Home/HomeStatsSection";

export const HomePage = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.scrollY;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Box sx={{ width: "100%", overflowX: "hidden" }}>
      <HomeSkyBackground />
      <HomeComponent />
      <Box
        sx={{
          position: "relative",
          zIndex: 5,
          py: { xs: 4, md: 5 },
          backgroundColor: "transparent",
        }}
      >
        <HomeStatsSection />
      </Box>
      <ContactContent />
    </Box>
  );
};